import shortid from "shortid"

function DiningItem({props}) {
  return (
    <div className="dining-item-container">
      <div className="dining-item">

        {/* Name */}
        <div className="di-name">
          <span>{props.name}</span>
        </div>

        {/* Spacer */}
        <div className="di-spacer">
          <span className="trans-text">text</span>
        </div>

        {/* Price */}
        <div className="di-price">
          {props.price.length === 1 ?
            <div>
              <span>${(props.price * 1).toFixed(2)}</span>
            </div> :
            props.price.map(item => (
              <div key={shortid.generate()}>
                <span>${(item * 1).toFixed(2)}</span>
              </div>
            ))}
        </div>
      </div>
      
      <div className="di-quan-unit">
        {props.quantity !== null || props.unit !== null ?
          <span>*</span> 
        : null}

        {/* Quantity */}
        {props.quantity ?
          <div className="di-quan">
            <span>{props.quantity}</span>
          </div> : null 
        }

        {/* Unit */}
        {props.unit !== null ?
          props.unit.map(item => (
            item === props.unit[props.unit.length - 1] ?
              <div className="di-unit" key={shortid.generate()}>
                <span>{`${item}`}</span>
              </div> :
              <div className="di-unit-x" key={shortid.generate()}>
                <span>{`${item} or`}</span>
              </div>
          )) 
        : null}
      </div>

      {/* Note */}
      <div className="di-note-container">
        {props.note !== null ?
            props.note.map(item => (
              item === props.note[props.note.length - 1] ?
                <div className="di-note" key={shortid.generate()}>
                  <span>{`${item}`}</span>
                </div> :
                <div className="di-note-x" key={shortid.generate()}>
                  <span>{`${item},`}</span>
                </div>
            )) 
          : null}
      </div>
    </div>
  )
}

export default DiningItem
